
export class Theme {
    id: number;
    title: string;
    createdAt: Date;

    constructor(theme?: { id?: number, title?: string, createdAt?: Date }) {
        if (theme) {
            this.id = theme.id;
            this.title = theme.title;
            this.createdAt = theme.createdAt;
        }
    }
}
